/*
 * jBone.widget.accordion
 *
 * You should define in your hmtl next structure with classes:
 *
 * .fn-accordion           to this element widget will add/remove class "expanded"
 * .fn-accordion-target    only by clicking on this element widget will add/remove class "expanded"
 * .fn-accordion-body      content inside will be "expanded" after click on accordion widget
 *
 * @param isCollapseSiblings defines whether or not content inside sibling accordion widgets should be hidden after expending
 * targeted accordion widget (basically, means, that only one widget can be expanded at a time)
 * // template.html
 * <div class="fn-accordion">
 *     <div class="fn-accordion-target">title text</div>
 *     <div class="fn-accordion-body">some content</div>
 * </div>
 *
 * // view.js
 * this.attachWidget(this.$el.accordion());
 *
 *
 */

define(function(require) {
    var $ = require('j');
    var i18n = require('i18n');
    var _ = require('underscore');

    require('common/jbone.widget');

    return $.widget('accordion', {

        options: {
            /*@deprecated opened class will no longer be supported*/
            expandedClass: 'accordion_expanded opened',
            headerExpandedClass: 'accordion-header_expanded',
            bodyExpandedClass: 'accordion-body_expanded',
            isCollapseSiblings: true
        },

        init: function(options) {
            _.extend(this.options, options);

            this.on(this.$el, {
                'tap .fn-accordion-target': this.toggleList,
                'tapHover .fn-accordion-target': this.manageHoverClass.bind(this, 'add'),
                'tapRemoveHover .fn-accordion-target': this.manageHoverClass.bind(this, 'remove')
            }, this);
        },

        _isIgnore: function(el) {
            return el.classList && el.classList.contains('fn-accordion-ignore');
        },

        manageHoverClass: function(action, e) {
            if (!this._isIgnore(e.currentTarget.parentNode)) {
                e.currentTarget.parentNode.classList[action]('hover');
            }
        },

        toggleList: function(e) {
            e.preventDefault();

            var currentAccordionItemHeader = e.currentTarget;
            var currentAccordionItem = currentAccordionItemHeader.parentNode;
            var currentAccordionItemBody = currentAccordionItem.querySelector('.fn-accordion-body');
            var accordionItems = currentAccordionItem.parentNode.querySelectorAll('.fn-accordion');

            if (this._isIgnore(currentAccordionItem)) {
                return;
            }

            currentAccordionItemHeader.setAttribute('aria-label',
                currentAccordionItemHeader.getAttribute('aria-label') === i18n.t('playtech.mobile.system.table.aria-label.expand')
                    ? i18n.t('playtech.mobile.system.table.aria-label.collapse')
                    : i18n.t('playtech.mobile.system.table.aria-label.expand'));
            this._classChangeOperator(currentAccordionItem, currentAccordionItemHeader, currentAccordionItemBody, 'toggle');

            if (!this.options.isCollapseSiblings || !accordionItems.length) {
                return;
            }

            [].forEach.call(accordionItems, function(accordionItem) {
                if (accordionItem !== currentAccordionItem) {
                    var accordionItemHeader = accordionItem.querySelector('.fn-accordion-target');
                    var accordionItemBody = accordionItem.querySelector('.fn-accordion-body');

                    this._classChangeOperator(accordionItem, accordionItemHeader, accordionItemBody, 'remove');
                }
            }.bind(this));
        },

        _classChangeOperator: function(item, header, body, action) {
            var changeClassFunction = function(className) {
                this.classList && this.classList[action](className);
            };

            var getExpandedState = function(el) {
                return el.classList && el.classList.contains('opened');
            };

            var isExpandedBefore = getExpandedState(item);

            this.options.expandedClass
            && this.options.expandedClass.split(' ').forEach(changeClassFunction, item);
            this.options.headerExpandedClass
            && this.options.headerExpandedClass.split(' ').forEach(changeClassFunction, header);
            this.options.bodyExpandedClass
            && this.options.bodyExpandedClass.split(' ').forEach(changeClassFunction, body);

            var isExpandedAfter = getExpandedState(item);
            var hasChanged = isExpandedBefore ^ isExpandedAfter;
            hasChanged && this._triggerExpandCollapseEvent(item, isExpandedAfter);
        },

        _triggerExpandCollapseEvent: function(item, isExpanded) {
            var eventName = isExpanded ? 'expand' : 'collapse';

            if (!isExpanded) {
                $(item).find('a.info-list__header').attr('aria-label', i18n.t('playtech.mobile.system.table.aria-label.expand'));
            }

            $(item).trigger(eventName);
        }
    });
});
